// vendor
import { Ref, ref, computed, watch } from "@vue/composition-api";

type UserPrefs = {
	menuOpen?:boolean;
	tagsCollapsed?:boolean;
}

const defaultPrefs:UserPrefs = { // note: necessary to let vue know props exist
	menuOpen:true,
	tagsCollapsed:false
};

let loaded = false;

let _prefs:Ref<UserPrefs>;

const readLS = <T>(key:string, fn:(v:T) => void) =>{
	const d = localStorage.getItem(key);
	if(!d){ return; }
	try {
		fn(JSON.parse(d) as T);
	}
	catch(err){}
}

export const useUserPrefs = () => {

	const savePrefs = () => {
		localStorage.setItem("user.prefs", JSON.stringify(_prefs.value));
	};

	const init = async () => {
		let old:any = {};
		readLS<UserPrefs>("user.prefs", v => old = v);
		_prefs = ref<UserPrefs>({
			...defaultPrefs,
			...old
		});
		watch(_prefs, savePrefs, {  deep:true }); // save on setting changes
	};

	if(!loaded){
		init();
		loaded = true;
	}

	const menuOpen = computed({
		get:() => Boolean(_prefs.value.menuOpen),
		set: v => _prefs.value.menuOpen = v
	});

	const tagsCollapsed = computed({
		get:() => Boolean(_prefs.value.tagsCollapsed),
		set: v => _prefs.value.tagsCollapsed = v
	});



	return {
		menuOpen,
		tagsCollapsed,
	};

};